import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const checkPlanLimitByFeature = async (feature) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}plan-limits/check/${feature}`, config)
    .then((response) => {
      return {
        data:
          typeof response.data?.available === 'boolean'
            ? response.data.available
            : response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error checkPlanLimitByFeature', error.response.data)
      return error
    })
}

export const checkSinglePostCountLimit = async () => {
  return await checkPlanLimitByFeature('art_generation_count')
}

export const checkCampaignInitiationLimit = async () => {
  return await checkPlanLimitByFeature('campaign_initiation')
}

export const checkAISuggestionLimit = async () => {
  return await checkPlanLimitByFeature('ai_suggestion')
}
